import { Routes, Route, useLocation } from "react-router-dom";
import { ThemeProvider } from "styled-components";
import { lightTheme } from "./components/Themes";
import { AnimatePresence } from "framer-motion";
import GlobalStyle from "./globalStyles";

//Components
import Main from "./components/Main";
import WorkPage from "./components/WorkPage";
import MySkillsPage from "./components/MySkillsPage";
import NavigationBar from "./subComponents/NavigationBar";
import PageHeader from "./subComponents/PageHeader";
import SocialIcons from "./subComponents/SocialIcons";

function App() {
  const location = useLocation();
  return (
    <>
      <GlobalStyle />

      <ThemeProvider theme={lightTheme}>
        <PageHeader />
        {/* For framer-motion animation on page change! */}
        <AnimatePresence mode='wait'>
          <Routes key={location.pathname} location={location} >
            <Route path="/" element={<Main />} />
            <Route path="/work" element={<WorkPage />} />
            <Route path="/skills" element={<MySkillsPage />} />

            {/* Catch-all: send unknown routes back to Home */}
            <Route path="*" element={<Main />} />
          </Routes>
        </AnimatePresence>
        <SocialIcons />
        {location.pathname !== "/" && <NavigationBar />}
      </ThemeProvider>
    </>
  );
}

export default App;
